export const MAX_IMAGE_ATTEMPTS = 3

const IMAGE_OBJECT_FIT_CLASSES = new Set([
  'object-cover',
  'object-contain',
  'object-fill',
  'object-none',
  'object-scale-down',
])

/** 仅提取 object-fit 类，避免把 object-position 类误判为 fit 覆盖。 */
export const getImageObjectFitClass = (classes: unknown) => {
  if (typeof classes !== 'string') return ''

  return classes.split(/\s+/).find((className) => IMAGE_OBJECT_FIT_CLASSES.has(className)) || ''
}

/** 根据当前总尝试次数决定继续重试还是对外暴露最终错误。 */
export const getImageErrorAction = (attemptCount: number, hasSource: boolean): 'retry' | 'error' =>
  hasSource && attemptCount < MAX_IMAGE_ATTEMPTS ? 'retry' : 'error'
